export default {
  updated() {
    this.$nextTick(this.throttleRegisterHanlink);
  },
  mounted() {
    this.throttleRegisterHanlink();
    const watcher = this.$options.hardwroldWatcher || [];
    watcher.forEach((key) =>
      this.$watch(key, () => {
        setTimeout(() => {
          this.$nextTick(this.registerHanlink);
        }, 30);
      }, {
        immediate: true,
        deep: true
      })
    );
  }
};
